const types = require('../../constants/actionTypes');

const rangeSelected = ({ minYear }) => ({
    type: types.PROFITABILITY_RANGE_SELECTED,
    payload: { minYear },
});

module.exports = rangeSelected;
